import React from 'react'

class InteresseAnDarthelfer extends React.Component {

    render() {
        return <div className="col-12 md:col-12 lg:col-3" style={{padding:10}}>
            <div className="kachelStartseite" style={{height:"100%"}}>
                <h3>Was kostet Darthelfer?</h3>
                <div style={{marginBottom:10}}><span style={{fontWeight:"bold"}}>Veranstalter</span> haben die Möglichkeit kostenlos Ihre Veranstaltungen zu verwalten. Mit der kostenlosen Version ist die Eingabe der Ergebnisse von Hand notwendig. Erweiterte Funktionen und automatischer Turnierverlauf mit dem darthelfer-scorer möglich. Registriere dich und schau dich unter dem Punkt Veranstalter um.</div>
                <div style={{marginBottom:10}}><span style={{fontWeight:"bold"}}>Ligabetreiber:</span> Veranstalte deine Onlineliga kostenlos und genieße eine vollautomatische Ligaverwaltung, auf Wunsch mit Autodartsanbindung.</div>
                <div style={{marginBottom:10}}><span style={{fontWeight:"bold"}}>Gamer/Benutzer:</span> Die Registrierung und das Gaming ist mit DH grundsätzlich kostenlos. Spiele Onlineevents und trainiere einfach von zuhause. Mit deinem Account kannst du dich schnell und komfortabel bei Veranstalterevents registrieren.<br/>In beiden Fällen hast du deine Spiele und deine Statistik immer im Blick.</div>
            </div>
        </div>
    }
}

export default InteresseAnDarthelfer;
